import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import { push } from "react-router-redux";
import { clearToken } from "../../helpers/utility";
import actions from "./actions";
import { isEmpty } from "lodash";

import { getUserProfile, getUserSession } from "../../services/index";

const fakeApiCall = true; // auth0 or express JWT

export function* loginRequest() {
  try {
    yield takeEvery("LOGIN_REQUEST", function*() {
      if (fakeApiCall) {
        yield put({
          type: actions.LOGIN_SUCCESS,
          token: "secret token",
          profile: "Profile",
        });
      } else {
        yield put({ type: actions.LOGIN_ERROR });
      }
    });
  } catch (e) {
    console.log("login error", e);
  }
}

export function* checkIsLoggedIn() {
  try {
    yield takeEvery("CHECK_LOGGED_IN", function*() {
      yield put({ type: "ISCHECKING_LOGGED_IN", isChecking_LoggedIn: true });

      const loggedIn = yield call(getUserProfile);
      const userSession = yield call(getUserSession);

      yield put({ type: "ISCHECKING_LOGGED_IN", isChecking_LoggedIn: false });

      if (!isEmpty(loggedIn)) {
        yield put({
          type: actions.LOGGED_IN,
          isLoggedIn: true,
        });
        yield put({
          type: actions.USER_AUTH_PROFILE,
          user_profile: userSession,
        });
      } else {
        yield put({
          type: actions.LOGGED_IN,
          isLoggedIn: false,
        });
        yield put({
          type: actions.USER_AUTH_PROFILE,
          user_profile: {},
        });
      }
    });
  } catch (e) {
    console.log("ERROR in Checking Session", e);
  }
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function*() {});
}

export default function* rootSaga() {
  yield all([
    fork(loginRequest),
    fork(loginError),
    fork(checkIsLoggedIn)
  ]);
}
